import type { InferOutput } from "valibot";
import { object } from "valibot";
import type { VariableDefinition } from "../Variable";
import { initVariable, VariableBaseSchema } from "../Variable";
import { isoDateString, require } from "../../utils/validation/base";
import { keyFromSelector } from "i18next";

const Schema = object({
  ...VariableBaseSchema.entries,
  defaultValue: require(isoDateString()),
});

export type DateVariableType = InferOutput<typeof Schema>;

const DateVariable: VariableDefinition<DateVariableType> = {
  type: "date",
  icon: "calendar",
  schema: Schema,
  ruleConditionBehaviour: {
    variant: "text",
    keys: ["hasValue"],
  },
  titleKey: keyFromSelector(($) => $.DATE_VARIABLE_LABEL),
};

export default initVariable(DateVariable);
